<template>
  <!--  v-if is in case the object model async fetch hasn't been received yet-->
  <loading :loading="!Boolean(handler.objectModel)">
    <template #loading>
      <collapsible-section
        :control-name="dropdownControlId"
        :id="dropdownControlId"
        :is-open="false"
        disabled
        class="collapse-item"
      >
        <template #section-header>
          <xpinner />
        </template>
      </collapsible-section>
    </template>
    <template #loaded>
      <collapsible-section
          class="collapse-item"
          :id="`objectModelDataCollapse-${handler.objectModel.client_id}-${dropdownControlId}`"
          control-name="objectModelDataCollapse"
          :disabled="handler.isSingleOnly && handler.isDisabled(handler.objectModel, computedChildTreeContext)"
          :is-open="isOpen(handler.hasObjectModelDataMatch(lowerQ, handler.objectModel))"
      >
        <template #section-header>
          <row>
            <prefix>
              <icon :glyph="varIOClass(handler.variable)"/>
            </prefix>
            <column>
              {{ handler.rootHeader }}
            </column>
          </row>
        </template>
        <template #section-contents>
          <section-fields
            v-if="handler.usersOnly"
            :q="q"
            :handler="handler"
            :section="userSection"
            icon-glyph="member"
            @select="select"
            :select-additional-parameters="[path]"
          />

          <template v-if="!handler.usersOnly">
            <object-model-property-data
              :handler="handler"
              :q="q"
              :object-model="handler.objectModel"
              :level="1"
              :path="path"
              default-open
              @select="select"
              :parent-tree-context="computedChildTreeContext"
            ></object-model-property-data>
            <object-model-user-data
              v-if="!handler.hideRecordHolderData"
              :handler="handler"
              :q="q"
              :object-model="handler.objectModel"
              :level="1"
              :path="path"
              default-open
              @select="select"
              :parent-tree-context="computedChildTreeContext"
            ></object-model-user-data>

            <object-model-linked-submissions-data
              v-if="handler.allowLinkSubmissions"
              :handler="handler"
              :q="q"
              :object-model="handler.objectModel"
              :path="path"
              @select="select"
              :parent-tree-context="computedChildTreeContext"
            ></object-model-linked-submissions-data>

            <object-model-record-metadata-data
              v-if="handler.showRecordMetaData"
              :handler="handler"
              :q="q"
              :object-model="handler.objectModel"
              :level="1"
              :path="path"
              default-open
              @select="select"
              :parent-tree-context="computedChildTreeContext"
            ></object-model-record-metadata-data>
          </template>
          <object-model-relationship-data
              v-if="handler.traverseRelatedObjectModels"
              :handler="handler"
              :q="q"
              :object-model="handler.objectModel"
              :level="1"
              :path="path"
              :parent-tree-context="computedChildTreeContext"
              @select="select"
              :from-model-view="fromModelView"
          ></object-model-relationship-data>
        </template>
      </collapsible-section>
    </template>
  </loading>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue';
import ObjectModelPropertyData from '~/components/dynamicFieldsTrees/handlerComponents/object-model-property-data.vue';
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {ReferenceNodeType} from "~/enums/referenceNodeType";
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
import {IDynamicTreeContext} from '~/interfaces/dynamicFieldsInterfaces';
import DynamicElementMixin from '~/components/dynamicFieldsTrees/handlerComponents/common/dynamic-element-mixin.vue';
import DynamicFieldsHandler from '~/models/dynamicFields/handlers/dynamicFieldsHandler'
import ObjectModelUserData from "~/components/dynamicFieldsTrees/handlerComponents/object-model-user-data.vue";
import FieldItem from '~/components/dynamicFieldsTrees/handlerComponents/common/field-item.vue';
import SectionFields from '~/components/dynamicFieldsTrees/handlerComponents/common/section-fields.vue'
import ObjectModelRecordMetadataData from "~/components/dynamicFieldsTrees/handlerComponents/object-model-metadata-data.vue";
import ObjectModelLinkedSubmissionsData from './object-model-linked-submissions-data.vue';

export default Vue.extend({
  mixins: [handlerComponentsMixin, handlerTreeContextMixin, DynamicElementMixin],
  components: {
    SectionFields,
    ObjectModelUserData,
    CollapsibleSection,
    ObjectModelPropertyData,
    FieldItem,
    ObjectModelRecordMetadataData,
    ObjectModelLinkedSubmissionsData,
  },
  props: {
    handler: {
      type: Object as () => DynamicFieldsHandler,
      required: true,
    },
    fromModelView: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    path(): Array<ReferencePathNode> {
      return [
          new ReferencePathNode(null, {reference_type: ReferenceNodeType.ProcessFlowVariable, reference_id: this.handler.variable.id}),
          new ReferencePathNode(null, {reference_type: ReferenceNodeType.ObjectModel, reference_id: this.handler.objectModel.id})
      ];
    },
    treeContext(): Partial<IDynamicTreeContext> {
      return {
        isTopLevelCollectionAssigned: false,
        referencePathNodesToLevel: this.path
        // do not send in parent here
      }
    },
    userSection() {
      return this.handler.userSection(this.handler.objectModel)
    },
  },
});
</script>